import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import AppContext from "../../../AppContext";
import useTickets from "../../../hooks/useTickets";
import { PAGE_STATE } from "../../../constants";
import List, { STATE } from "../../List";
import SecondaryPagination from "../../SecondaryPagination/SecondaryPagination";
import { format } from "date-fns";

const columns = [
  {
    display: "Ticket No",
    key: "no",
    textAlign: "left",
    maxWidth: 80,
  },
  {
    display: "Category",
    key: "category",
    textAlign: "left",
    maxWidth: 100,
  },
  {
    display: "Topic",
    key: "topic",
    textAlign: "left",
    maxWidth: 400,
  },
  {
    display: "Requested on",
    key: "createdOn",
    textAlign: "left",
    maxWidth: 150,
  },
  {
    display: "Status",
    key: "status",
    textAlign: "left",
    maxWidth: 100,
  },
];

const Tickets = ({ onTicketSelect }) => {
  const { user } = useContext(AppContext);
  const { queryTickets } = useTickets();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [defaultFilter, setDefaultFilter] = useState({
    createdBy: user._id,
  });
  const [filter, setFilter] = useState({});
  const [tickets, setTickets] = useState([]);
  const [dataState, setDataState] = useState(STATE.LOADING);
  const [metadata, setMetadata] = useState({
    currentPage: 1,
    totalPages: 0,
  });

  useEffect(() => {
    fetchData(filter, page, limit);
    return () => {};
  }, [filter, page, limit]);

  const fetchData = async (filter, page, limit) => {
    const { data, _metadata } = await queryTickets(
      {
        ...defaultFilter,
        ...filter,
      },
      page,
      limit,
      {
        topic: 1,
        createdOn: 1,
        closed: 1,
        category: 1,
        no: 1,
      },
      {
        createdOn: -1,
      }
    );

    const _tickets = data.map(
      ({ _id, no, topic, category, createdOn, closed }) => {
        return {
          _id,
          no: (no ?? 1).toString().padStart(6, "0"),
          topic,
          createdOn: format(new Date(createdOn), "dd/MM/yyyy HH:mm"),
          status: closed ? "Closed" : "Open",
          category: category === 1 ? "Hero Banner" : "-",
        };
      }
    );

    setTickets(_tickets);
    setMetadata(_metadata);
    setDataState(STATE.IDLE);
  };

  const handleOnPageChange = (page) => setPage(page);

  const handleOnLimitChange = (limit) => {
    setPage(1);
    setLimit(limit);
  };

  const handleSelected = (row) => {
    onTicketSelect(row._id);
  };

  return (
    <div className="tickets">
      <h2 className="tickets__heading1">My Support Tickets</h2>
      <List
        className="admin-lp-hb-lists"
        contentState={dataState}
        columns={columns}
        dataSource={tickets}
        viewable={true}
        onRecordClick={(e) => handleSelected(e)}
      >
        <SecondaryPagination
          limits={[10, 50]}
          defaultPage={metadata?.currentPage || 1}
          pages={metadata?.totalPages || 1}
          defaultLimit={metadata?.pageSize || 10}
          onPageChange={handleOnPageChange}
          onLimitChange={handleOnLimitChange}
        />
      </List>
    </div>
  );
};

Tickets.propTypes = {};

export default Tickets;
